export let QboItemsStatus = /*#__PURE__*/function (QboItemsStatus) {
  QboItemsStatus["Success"] = "success";
  QboItemsStatus["RequestTimeout"] = "request-timeout";
  return QboItemsStatus;
}({});